"use client";
import { useCallback, type ComponentProps } from "react";
import { NextStep } from "nextstepjs";
import { tours } from "../lib/tours";
import { TourType } from "~/types/tour";
import { useTour } from "~/contexts/TourContext";

interface TourCompletionHandlerProps {
  children: React.ReactNode;
}

type NextStepOnSkip = NonNullable<ComponentProps<typeof NextStep>["onSkip"]>;

export default function TourCompletionHandler({
  children,
}: TourCompletionHandlerProps) {
  const { completeTour } = useTour();
  const handleTourComplete = useCallback(
    (tourName: string | null) => {
      if (tourName) completeTour(tourName as TourType);
    },
    [completeTour],
  );

  const handleTourSkip = useCallback<NextStepOnSkip>(
    (_step, tourName) => {
      handleTourComplete(tourName);
    },
    [handleTourComplete],
  );

  return (
    <NextStep
      steps={tours}
      onComplete={handleTourComplete}
      onSkip={handleTourSkip}
    >
      {children}
    </NextStep>
  );
}
